import { convertToExportedView } from '@estee/elc-service';
import { PRODUCT_RATING } from '@estee/elc-service-view-names';
import { IProductRating } from './ProductRating';
import serviceNames from '~setup/RatingsReviewsService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IProductRating>(
    () => import('./ProductRating'),
    PRODUCT_RATING,
    serviceNames.productRatingViewController
);
